// Global Instructions Rule Applied!
//
// Help "?" text for the Introduced by / Sourced by / Lead fields (owner
// 2026-10-02). They read alike but are different people: an outside party who
// made the introduction, the team member who brought the opportunity in, and
// the team member who now runs it. One wording for the deal, prospect and
// account forms.

/** What the form calls the account the contact is linked to. */
export type SourcingAccountNoun = 'company' | 'investor' | 'company or investor'

export const introducedByHelp = (accountNoun: SourcingAccountNoun): string =>
  `The external party that introduced us to the ${accountNoun}.`

export const SOURCED_BY_HELP = 'The internal team member who sourced the opportunity.'

export const leadHelp = (recordNoun: 'deal' | 'prospect'): string =>
  `The internal team member with primary responsibility for the ${recordNoun}.`
